import ActionTypes from "../constants/ActionTypes";

const defaultState = {
    loading: false,
    error: null,
    clubs: [],
};

const clubsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_CLUBS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ActionTypes.FETCH_CLUBS_SUCCESS:
            return {
                ...state,
                loading: false,
                clubs: action.clubs,
            };
        case ActionTypes.FETCH_CLUBS_FAIL:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};

export default clubsReducer;
